import { axiosAssessmentInstance } from "../AxiosConfiguration";

/**
 * Periodic Table of the Self read APIs (core-lambda periodic_table_module,
 * `/api/v4/periodic-table`).
 *
 * Member-scoped, never a catalogue: every payload is the member's own
 * behavioural model. A locked domain carries its name, Discovery and Element
 * count but no `elements` field at all. 503 means "could not read — retry",
 * never "the member has built nothing".
 */

const unwrap = (res) => {
  const data = res?.data;
  if (data && typeof data === "object") return data.payload ?? data;
  return data;
};

export const DOMAIN_REVEAL_STATUS = {
  REVEALED: "REVEALED",
  AVAILABLE: "AVAILABLE",
  LOCKED: "LOCKED",
  EMERGES: "EMERGES",
};

/** Canonical domain path values (never the legacy `Motivation`). */
export const DOMAINS = [
  "IDENTITY",
  "COGNITION",
  "RESOLUTION",
  "MOTIVES",
  "JUDGMENT",
];

/** The four activation levels, in display order. Descriptive, never a ranking. */
export const ELEMENT_LEVELS = ["Primary", "Active", "Moderate", "Subtle"];

/** `GET /api/v4/periodic-table` — every domain, revealed or not. */
export const getPeriodicTable = async () => {
  const res = await axiosAssessmentInstance.get("/api/v4/periodic-table");
  return unwrap(res);
};

/** `GET /api/v4/periodic-table/domains/{domain}` — one domain (locked answers
 * with name + count, not an error). */
export const getDomain = async (domain) => {
  const res = await axiosAssessmentInstance.get(
    `/api/v4/periodic-table/domains/${encodeURIComponent(domain)}`
  );
  return unwrap(res);
};

/** `GET /api/v4/periodic-table/elements/{name}` — one Element as the member's
 * own. 404 outside the canonical 35; 403 when its domain is still locked. */
export const getElement = async (name) => {
  const res = await axiosAssessmentInstance.get(
    `/api/v4/periodic-table/elements/${encodeURIComponent(name)}`
  );
  return unwrap(res);
};

/** `GET /api/v4/periodic-table/levels` — revealed Elements grouped by level;
 * all four groups always present, empty groups included. */
export const getLevels = async () => {
  const res = await axiosAssessmentInstance.get(
    "/api/v4/periodic-table/levels"
  );
  return unwrap(res);
};

/** `GET /api/v4/periodic-table/levels/{level}` — one level with the
 * Talk-with-Aris CTA. */
export const getLevel = async (level) => {
  const res = await axiosAssessmentInstance.get(
    `/api/v4/periodic-table/levels/${encodeURIComponent(level)}`
  );
  return unwrap(res);
};
